import { IState } from '../types';
import { ILoginPopupState } from './types';

export class LoginPopupSelectors {

	public static getLoginPopup(state: IState): ILoginPopupState {
		return state.loginPopup;
	}

}